export enum ResponseType {
  YES_NO = "YES_NO",

  FREE_TEXT = "FREE_TEXT",

  LINK = "LINK",

  ATTACH_FILE = "ATTACH_FILE",
}
